import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PaperPlane = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.563 3.34a1.002 1.002 0 00-.989-.079l-17 8a1 1 0 00.026 1.821L8 15.445v6.722l5.836-4.168 4.764 2.084a1 1 0 001.399-.85l1-15a1.005 1.005 0 00-.436-.893zm-2.466 14.34l-5.269-2.306L16 9.167l-7.649 4.25-2.932-1.283 13.471-6.34-.793 11.886z",
    key: "k0"
  }));
});
PaperPlane.displayName = 'PaperPlane';
export var PaperPlaneDimensions = {
  height: 24,
  width: 24
};